import React from 'react';
import { INTERFACE_LANGUAGES, isInterfaceLanguage } from './languages';
import { useLanguage } from './LanguageContext';

const FOLLOW = 'follow_microsoft_365';

/**
 * The same choices as the SPFx selector: "Use my Microsoft 365 language",
 * then each language by its own name — never a flag (tracker #119).
 */
export const LanguageSelector = (): JSX.Element => {
  const { choice, choose, t, saveFailed } = useLanguage();
  const value = choice?.mode === 'language' ? choice.language : FOLLOW;
  return (
    <span className="language-selector">
      <select
        aria-label={t('Language.SelectorLabel')}
        title={t('Language.SelectorLabel')}
        value={value}
        onChange={(event) => {
          const selected = event.target.value;
          void choose(isInterfaceLanguage(selected) ? { mode: 'language', language: selected } : { mode: 'follow_microsoft_365', language: null });
        }}
      >
        <option value={FOLLOW}>{t('Language.FollowMicrosoft365')}</option>
        {INTERFACE_LANGUAGES.map((entry) => (
          <option key={entry.tag} value={entry.tag} lang={entry.tag}>
            {entry.nativeName}
          </option>
        ))}
      </select>
      {saveFailed && <span role="status" className="language-selector-note">{t('Language.SaveFailed')}</span>}
    </span>
  );
};
